import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    profiledata: [],
};

const profileData = createSlice({
    name: "profiledata",
    initialState,
    reducers: {
        setProfileData(state, action) {
            state.profiledata = JSON.parse(JSON.stringify(action.payload));
        },
    },
});

export const { setProfileData } = profileData.actions;

export default profileData.reducer;
